import gql from 'graphql-tag'
import marketplaceCheckoutFragment from '../fragments/marketplace-checkout'

export default gql`
  query MarketplaceCheckout(
    $id: UUID!
    $preferredFulfilmentType: MarketplaceFulfilmentType
    $deliveryLocation: MarketplaceDeliveryLocationInput
    $pickupCentreSlug: String
  ) {
    checkout: marketplaceCheckout(
      id: $id
      preferredFulfilmentType: $preferredFulfilmentType
      deliveryLocation: $deliveryLocation
      pickupCentreSlug: $pickupCentreSlug
    ) {
      ...marketplaceCheckout
    }
  }

  ${marketplaceCheckoutFragment}
`
